import React, { Component } from "react";
import loadingGif from "../../../images/fl-loader.gif";

export class LoadingModal extends Component {
  render() {
    return (
      <div className="modal-window">
          <div>
            <div className="col-sm">
              <div className="loading-icon">
                <img className="loading-icon" src={loadingGif} alt="Loading icon." />
              </div>
            </div>
          </div>
        </div>
    );
  }
}
export default LoadingModal;